export const NEW_PEDIGREE_ACTION_TYPES = {
    getFolders: 'NEW_PEDIGREE_get_folders',
    getQuestionnaires: 'NEW_PEDIGREE_get_questionnaires',
    checkPedigreeName: 'NEW_PEDIGREE_check_pedigree_name',
    resetPedigreeNameError: 'NEW_PEDIGREE_reset_pedigree_name_error',
    launchPedigreeTab: 'NEW_PEDIGREE_launch_pedigree_tab'
};

export const PEDIGREE_GENDER = {
    male: 1,
    female: 0
};